import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const HIDE_ON_PATHS = ["/student-registration", "/campus-registration"];

const FloatingRegistrationButtons = () => {
  const [hovered, setHovered] = useState(null);
  const location = useLocation();

  // Don't show the buttons on the registration pages themselves
  if (HIDE_ON_PATHS.includes(location.pathname)) return null;

  return (
    <div className="fixed bottom-6 right-5 z-[9999] flex flex-row items-center gap-3">
      {/* Student Registration */}
      <Link
        to="/student-registration"
        onMouseEnter={() => setHovered("student")}
        onMouseLeave={() => setHovered(null)}
        className="flex items-center gap-2 px-4 py-2.5 rounded-full text-white text-sm font-semibold shadow-lg transition-all duration-300"
        style={{
          pointerEvents: "auto",
          backgroundColor: hovered === "student" ? "#024a1e" : "#035925",
          boxShadow:
            hovered === "student"
              ? "0 8px 24px rgba(3,89,37,0.55)"
              : "0 4px 14px rgba(3,89,37,0.4)",
          transform: hovered === "student" ? "translateY(-2px) scale(1.03)" : "none",
        }}
      >
        {/* Person icon */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          className="w-4 h-4 shrink-0"
        >
          <path d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z" />
        </svg>
        Student Registration
      </Link>

      {/* Campus Registration */}
      <Link
        to="/campus-registration"
        onMouseEnter={() => setHovered("campus")}
        onMouseLeave={() => setHovered(null)}
        className="flex items-center gap-2 px-4 py-2.5 rounded-full text-white text-sm font-semibold shadow-lg transition-all duration-300"
        style={{
          pointerEvents: "auto",
          backgroundColor: hovered === "campus" ? "#024a1e" : "#035925",
          boxShadow:
            hovered === "campus"
              ? "0 8px 24px rgba(3,89,37,0.55)"
              : "0 4px 14px rgba(3,89,37,0.4)",
          transform: hovered === "campus" ? "translateY(-2px) scale(1.03)" : "none",
        }}
      >
        {/* Building icon */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          className="w-4 h-4 shrink-0"
        >
          <path d="M3 21V7l9-4 9 4v14H3zm2-2h4v-4H5v4zm6 0h4v-4h-4v4zm6 0h2v-4h-2v4zM5 13h4V9H5v4zm6 0h4V9h-4v4zm6 0h2V9h-2v4z" />
        </svg>
        Campus Registration
      </Link>
    </div>
  );
};

export default FloatingRegistrationButtons;
